import { render, staticRenderFns } from "./TarifaTransbordador.vue?vue&type=template&id=19075998&"
import script from "./TarifaTransbordador.vue?vue&type=script&lang=js&"
export * from "./TarifaTransbordador.vue?vue&type=script&lang=js&"
import style0 from "./TarifaTransbordador.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports